// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { cn } from "@/lib/utils";

interface RowIdProps {
  id: number | string;
  className?: string;
}

/**
 * Renders an entity ID inside a data-table row in a consistent monospace style.
 * Lightweight by design — no copy affordance (that's `IdPill`, used on detail headers).
 */
export function RowId({ id, className }: RowIdProps) {
  return <span className={cn("font-mono tabular-nums", className)}>{id}</span>;
}
